<template>
  <van-dialog
    class="custom-dialog"
    v-bind="$attrs"
    v-on="$listeners"
    :show-cancel-button="false"
    :show-confirm-button="false"
    get-container="body"
  >
    <div class="custom-body">
      <div class="header">
        <slot name="header">{{ options.title }}</slot>
      </div>
      <div class="form-input">
        <input
          @input="handleInput"
          v-model="num"
          type="text"
          :maxlength="maxLength"
          :placeholder="options.placeholder"
        />
      </div>
      <div class="footer">
        <span @click="$emit('input', false)" class="cancel">{{
          options.cancelText || '取消'
        }}</span>
        <span @click="$emit('confirm')" class="confirm">{{
          options.confirmText || '确定'
        }}</span>
      </div>
    </div>
  </van-dialog>
</template>

<script>
export default {
  name: 'InputDialog',
  props: {
    inputNum: [Number, String],
    options: {
      type: Object,
      default: () => {
        return {
          title: '发送积分',
          placeholder: '请输入要发送的积分'
        }
      }
    },
    onlyNumber: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    maxLength: {
      type: Number,
      default: () => {
        return 6
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    num: {
      get() {
        return this.$props.inputNum
      },
      set(val) {
        this.$emit('update:inputNum', val)
      }
    }
  },
  methods: {
    handleInput(e) {
      if (this.onlyNumber) {
        this.num = e.target.value.replace(/[^\d]/g, '')
      } else {
        this.num = e.target.value
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-dialog {
  width: 100%;
  border-radius: 16px;
}
.custom-body {
  width: 100%;
  padding: 24px 16px 16px;
  box-sizing: border-box;
  background: #fff;
  height: 50px;
  min-height: 195px;
  .header {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #202124;
    line-height: 23px;
    text-align: center;
    font-style: normal;
    text-align: center;
  }
  .form-input {
    width: 100%;
    height: 50px;
    border-radius: 10px;
    border: 1px solid #eceeef;
    margin: 16px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 13px;
      color: #202124;
      text-align: center;
    }
  }
  .footer {
    display: flex;
    align-items: center;
    gap: 10px;
    span {
      flex: 1;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #202124;
      line-height: 14px;
      text-align: center;
      font-style: normal;
      border-radius: 10px;
      &.cancel {
        background: #f5f6f7;
        color: rgba(32, 33, 36, 0.6);
      }
      &.confirm {
        background: linear-gradient(270deg, #00a5ff 0%, #006cff 100%);
        color: #fff;
      }
    }
  }
}
</style>
